module.exports = __webpack_public_path__ + "img/Feature.89f2ecbc.jpg";